import { t } from 'i18next';
import { RouteObject } from 'react-router-dom';
import { BaseOutlet } from '../../../../components/BaseOutlet/BaseOutlet';
import { LessonClassDetailSubpage } from './LessonClassDetailSubpage';
import { LessonClassesSubpage } from './LessonClassesSubpage';
import { LessonOverviewSubpage } from './LessonOverviewSubpage';
import { LessonSubjectDetailSubpage } from './LessonSubjectDetailSubpage';
import { LessonSubjectsSubpage } from './LessonSubjectsSubpage';
import { LessonTeacherDetailSubpage } from './LessonTeacherDetailSubpage';
import { LessonTeachersSubpage } from './LessonTeachersSubpage';

export const lessonRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      element: <LessonOverviewSubpage />,
      index: true,
    },

    {
      path: t('routes.lessons.plan.classes.slug'),
      element: <BaseOutlet />,
      handle: {
        crumb: () => {
          return {
            slug: `${baseSlug}/${t('routes.lessons.slug')}/${t('routes.lessons.plan.classes.slug')}`,
            title: t('routes.lessons.plan.classes.title'),
          };
        },
      },
      children: [
        {
          element: <LessonClassesSubpage />,
          index: true,
        },
        {
          path: ':classUuid',
          element: <LessonClassDetailSubpage />,
        },
      ],
    },

    {
      path: t('routes.lessons.plan.subjects.slug'),
      element: <BaseOutlet />,
      handle: {
        crumb: () => {
          return {
            slug: `${baseSlug}/${t('routes.lessons.slug')}/${t('routes.lessons.plan.subjects.slug')}`,
            title: t('routes.lessons.plan.subjects.title'),
          };
        },
      },
      children: [
        {
          element: <LessonSubjectsSubpage />,
          index: true,
        },
        {
          path: ':subjectUuid',
          element: <LessonSubjectDetailSubpage />,
        },
      ],
    },

    {
      path: t('routes.lessons.plan.teachers.slug'),
      element: <BaseOutlet />,
      handle: {
        crumb: () => {
          return {
            slug: `${baseSlug}/${t('routes.lessons.slug')}/${t('routes.lessons.plan.teachers.slug')}`,
            title: t('routes.lessons.plan.teachers.title'),
          };
        },
      },
      children: [
        {
          element: <LessonTeachersSubpage />,
          index: true,
        },
        {
          path: ':teacherUuid',
          element: <LessonTeacherDetailSubpage />,
        },
      ],
    },
  ];
};
